import { lazy, Suspense } from "react";
import { Link } from "react-router";
import type { ScheduleEntry } from "@edu/shared";
import { useSession } from "../../lib/session.tsx";
import { occurrenceKeyOfEntry } from "./entry-marks.ts";

/**
 * Слова занятия в карточке занятия (8.2, 8.3 `docs/flashcards-design.md`).
 *
 * Кому что видно, решает СЕРВЕР двумя полями строки сетки, и второй проверки
 * роли или предмета здесь нет намеренно: `wordsField` приезжает только
 * преподавателю английской (или без предмета) пары, `wordsCount` только
 * ученику и только когда колода ему видна. Сетку читают обе стороны одной
 * ручкой, и правило видимости живёт в одном месте, на сервере.
 *
 * ⚠️ Само поле ленивым чанком: оно преподавательское, а карточка занятия в
 * стартовом чанке у всех, включая ученика (5.1 CLAUDE.md).
 */
const WordsField = lazy(() =>
  import("../flashcards/WordsField.tsx").then((m) => ({ default: m.WordsField })),
);

export function EntryWords(props: { entry: ScheduleEntry }) {
  const { entry } = props;
  const { state } = useSession();

  if (entry.myRole === "student") {
    if (entry.wordsCount === undefined) return null;
    return (
      <p className="muted">
        <Link className="textlink" to="/flashcards/train">
          Слова занятия: {String(entry.wordsCount)}
        </Link>
      </p>
    );
  }

  if (entry.wordsField !== true || entry.counterpartUserId === null || state.status !== "signed") return null;
  const occurrence = occurrenceKeyOfEntry(entry);
  if (occurrence === null) return null;

  return (
    <Suspense fallback={null}>
      <WordsField userId={state.me.userId} studentUserId={entry.counterpartUserId} occurrence={occurrence} />
    </Suspense>
  );
}
